export interface SetupMark { phase: string; elapsedMs: number; at: string; detail?: string }
export type SetupTrace = (phase: string, detail?: string) => void;
let marks: SetupMark[] = [];
const listeners = new Set<() => void>();

export function setupTraceEnabled(): boolean {
  return new URLSearchParams(window.location.search).get("setupTrace") === "1";
}
export function readSetupTrace(): SetupMark[] { return marks; }
export function subscribeSetupTrace(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function createSetupTrace(): SetupTrace {
  if (!setupTraceEnabled()) return () => {};
  const started = performance.now();
  marks = [];
  return (phase, detail) => {
    // Only fixed phase names, states and candidate types/counts: no SDP, addresses or credentials.
    marks = [...marks, { phase, elapsedMs: Math.round(performance.now() - started), at: new Date().toISOString(), ...(detail ? { detail } : {}) }].slice(-60);
    listeners.forEach(listener => listener());
  };
}
